export default __webpack_public_path__ + "static/media/work5.37759dfc.svg";